import { useSelector, shallowEqual } from 'react-redux';
import { getRaces } from '../selectors';

export const useRacesFacade = () => ({
  races: useSelector(getRaces, shallowEqual),
});
